<ep-device-form [form]="deviceForm" [mode]="(mode$ | async)!"></ep-device-form>
